<template>
  <div>
    <div v-if="$page.props.flash.success && show" class="container">
        <div class="mt-5 alert alert-success alert-dismissible fade show" role="alert">
            <i class="fa fa-check-circle"></i> {{ $page.props.flash.success }}
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" @click="show = false"></button>
        </div>
    </div>
    <div v-if="($page.props.flash.error || Object.keys($page.props.errors).length > 0) && show" class="container">
        <div class="mt-5 alert alert-danger alert-dismissible fade show" role="alert">
            <div v-if="$page.props.flash.error"><i class="fa fa-exclamation-circle"></i> {{ $page.props.flash.error }}</div>
            <div v-else>
                <span v-if="Object.keys($page.props.errors).length === 1"><i class="fa fa-exclamation-circle"></i> There is one form error.</span>
                <span v-else><i class="fa fa-exclamation-circle"></i> There are {{ Object.keys($page.props.errors).length }} form errors.</span>
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" @click="show = false"></button>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: true,
    }
  },
  watch: {
    '$page.props.flash': {
      handler() {
        this.show = true
      },
      deep: true,
    },
  },
}
</script>
